import React, { useCallback, useState } from 'react';
import { useAuth } from '../services/AuthContext';

export const LoginPanel: React.FC = () => {
  const { token, setToken, clearToken, isAuthenticated } = useAuth();
  const [draft, setDraft] = useState(token);
  const [status, setStatus] = useState<string | null>(null);

  const save = useCallback(() => {
    setToken(draft.trim());
    setStatus(draft.trim() ? 'Token saved' : 'Token cleared');
    setTimeout(() => setStatus(null), 2000);
  }, [draft, setToken]);

  const clear = useCallback(() => {
    setDraft('');
    clearToken();
    setStatus('Token cleared');
    setTimeout(() => setStatus(null), 2000);
  }, [clearToken]);

  return (
    <div>
      <div className="panel-section">
        <div className="panel-section-title">API Authentication</div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 }}>
          Paste the bearer token issued for this deployment. Leave blank if your
          server does not require authentication.
        </p>
        <input
          type="password"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Bearer token"
          autoComplete="off"
          style={{
            width: '100%',
            padding: 8,
            fontFamily: 'monospace',
            fontSize: 12,
            background: 'var(--surface, #1E293B)',
            color: 'var(--text-primary, #F1F5F9)',
            border: '1px solid var(--border, #334155)',
            borderRadius: 4,
          }}
        />
        <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
          <button className="btn btn-primary" onClick={save} style={{ flex: 1 }}>Save</button>
          <button className="btn btn-secondary" onClick={clear} style={{ flex: 1 }}>Clear</button>
        </div>
        {status && (
          <div style={{ marginTop: 6, fontSize: 11, color: 'var(--text-muted)' }}>{status}</div>
        )}
        <div style={{ marginTop: 8, fontSize: 11 }}>
          Status:{' '}
          <strong style={{ color: isAuthenticated ? 'var(--success, #22C55E)' : 'var(--warning, #F59E0B)' }}>
            {isAuthenticated ? 'Authenticated' : 'Unauthenticated'}
          </strong>
        </div>
      </div>
    </div>
  );
};
